import { lazy } from "react";
import PrivateRoute from "./PrivateRoute.component";
import ProtectedRoute from "./ProtectedRoute";
import NAVIGATION_PATH from "../../constants/navigationConstant";
import { ROUTES } from "../../constants/routeConstant";

const {
  ORDERS,
  MY_ORGANIZATION,
  USERS,
  PAYMENT_PROFILE,
  LOCATION,
  PROFILE,
  USER_ASSIGNMENT,
  DEBUG_LOGS,
  TAKE_PAYMENT,
  DASHBOARD,
  CATEGORY_LIST,
  INVENTORY_DASHBOARD,
  TRANSACTION,
  CASHLESS_PAYMENTS,
  CASH_PAYMENTS,
  MEMBER_PAYMENTS,
  TRANSACTION_ITEMS,
  FUNDRAISER_EVENTS,
  FUNDRAISER_USERS,
  DEVICE_REBOOT,
  LOGIN
} = NAVIGATION_PATH;

const { TRANSACTION_ITEM_SUMMARY } = ROUTES;

export const routes = {
  login: {
    name: "Login",
    path: LOGIN,
    component: lazy(() => import("../../components/login/Login")),
    type: ProtectedRoute,
  },
  transaction: {
    name: "All Transactions",
    path: TRANSACTION,
    component: lazy(() => import("../../components/Transaction/transaction")),
    type: PrivateRoute,
  },
  transactionItems: {
    name: TRANSACTION_ITEM_SUMMARY,
    path: TRANSACTION_ITEMS,
    component: lazy(() => import("../../components/Transaction/TransactionItems")),
    type: PrivateRoute,
  },
  profile: {
    name: "Profile Items",
    path: PROFILE,
    component: lazy(() => import("../../components/profile/ProfileItems")),
    type: PrivateRoute,
  },
  paymentProfile: {
    name: "Payment Profiles",
    path: PAYMENT_PROFILE,
    component: lazy(() => import("../../components/profile/PaymentProfiles")),
    type: PrivateRoute,
  },
  location: {
    name: "Location",
    path: LOCATION,
    component: lazy(() => import("../../components/location/Location")),
    type: PrivateRoute,
  },
  userAssignment: {
    name: "User Assignment",
    path: USER_ASSIGNMENT,
    component: lazy(() => import("../../components/profile/UserAssignment")),
    type: PrivateRoute,
    role: ["admin"]
  },
  memberPayments: {
    name: "Member/Room Payments",
    path: MEMBER_PAYMENTS,
    component: lazy(() => import("../../components/payments/MemberPayment")),
    type: PrivateRoute,
  },
  cashlessPayments: {
    name: "Card Payments",
    path: CASHLESS_PAYMENTS,
    component: lazy(() => import("../../components/payments/CardPayments")),
    type: PrivateRoute,
  },
  cashPayments: {
    name: "Cash Payments",
    path: CASH_PAYMENTS,
    component: lazy(() => import("../../components/payments/CashPayments")),
    type: PrivateRoute,
  },
  orders: {
    name: "Orders",
    path: ORDERS,
    component: lazy(() => import("../../components/order/Order")),
    type: PrivateRoute,
  },
  users: {
    name: "Users",
    path: USERS,
    component: lazy(() => import("../../components/users/Users")),
    type: PrivateRoute,
    role: ["admin"]
  },
  myorganisation: {
    name: "My Organization",
    path: MY_ORGANIZATION,
    component: lazy(() => import("../../components/organisation/MyOrganisation")),
    type: PrivateRoute,
    role: ["admin"]
  },
  debuglogs: {
    name: "Debug Logs",
    path: DEBUG_LOGS,
    component: lazy(() => import("../../components/debugLogs/DebugLogs")),
    type: PrivateRoute,
  },
  dashboard: {
    name: "Dashboard",
    path: DASHBOARD,
    component: lazy(() => import("../../components/Transaction/Dashboard")),
    type: PrivateRoute,
  },
  takePayment: {
    name: "Take Payment",
    path: TAKE_PAYMENT,
    component: lazy(() => import("../../components/takePayment/takePayment")),
    type: PrivateRoute,
  },
  categoryList: {
    name: "Category List",
    path: CATEGORY_LIST,
    component: lazy(() => import("../../components/categoryList/categoryList")),
    type: PrivateRoute,
  },
  inventoryDashboard: {
    name: "Inventory Dashboard",
    path: INVENTORY_DASHBOARD,
    component: lazy(() => import("../../components/inventoryDashboard/inventoryDashboard")),
    type: PrivateRoute,
  },
  events: {
    name: "Events",
    path: FUNDRAISER_EVENTS,
    component: lazy(() => import("../../components/events/Events")),
    type: PrivateRoute,
    role: ["admin"]
  },
  fundraiserUsers: {
    name: "Fundraiser Users",
    path: FUNDRAISER_USERS,
    component: lazy(() => import("../../components/users/Users")),
    type: PrivateRoute,
    role: ["admin"]
  },
  deviceReboot: {
    name: "Device Reboot",
    path: DEVICE_REBOOT,
    component: lazy(() => import("../../components/deviceReboot/DeviceReboot")),
    type: PrivateRoute,
  },
  emptyRoute: {
    name: "Login",
    path: "/",
    component: lazy(() => import("../../components/login/Login")),
    type: ProtectedRoute,
  },
  page404:{
    name:"404 page",
    path:"*",
    component: lazy(()=> import("../../components/pageNotFound/pageNotFound")),
    type:PrivateRoute
  }
};

export const renderRoutes = Object.entries(routes);